import * as z from "zod";
//#region src/models/stringToArrayModel.ts
/**
* ! Required for Array-like query-string parameters, e.g. `?case_types=accident,damage`
*
* ! This is needed, since Hono's validators doesn't access `c.req.queries`, only `c.req.query`
*
* Transforms string to array, e.g. `accident,damage` → `["accident", "damage"]`
*/
const stringToArrayModel = (schema) => z.preprocess((v) => typeof v === "string" && v.length > 0 ? v.split(",").map((s) => s.trim()).filter(Boolean) : void 0, schema);
//#endregion
export { stringToArrayModel };
